import Pedido, {
  FiltroPesquisarPedido,
  FiltroRelatorio,
} from "../Components/Shared/Interfaces/Pedido";
import { FiltroRelatorioPedidosPorCliente } from "../Components/Shared/Interfaces/RelatorioPedidosPorCliente";
import { ServiceBase } from "./ServiceBase";

export class PedidoService extends ServiceBase {
  async postPedido(url: string, body: Pedido) {
    return this.post(url, body);
  }

  async putPedido(url: string, body: Pedido) {
    return this.put(url, body);
  }

  async getAll(url: string) {
    return this.get(url);
  }

  async deleteItem(url: string) {
    return this.delete(url);
  }

  async buscarPor(body: FiltroPesquisarPedido) {
    let url = "/api/Pedidos/BuscarPor";
    return this.post(url, body);
  }

  async gerarRelatorioPedidos(body: FiltroRelatorio) {
    let url = "/api/Relatorios/GerarRelatorioPedidos";
    return this.post(url, body);
  }

  async gerarRelatorioPedidosPorCanal(body: FiltroRelatorio) {
    let url = "/api/Relatorios/GerarRelatorioPedidosPorCanal";
    return this.post(url, body);
  }

  async gerarRelatorioPedidosPorDiaECanal(body: FiltroRelatorio) {
    let url = "/api/Relatorios/GerarRelatorioPedidosPorDiaECanal";
    return this.post(url, body);
  }

  async gerarRelatorioPedidosPorDiaSemana(body: FiltroRelatorio) {
    let url = "/api/Relatorios/PedidosPorDia";
    return this.post(url, body);
  }

  async gerarRelatorioPedidosPorMes(body: FiltroRelatorio) {
    let url = "/api/Relatorios/PedidosPorMes";
    return this.post(url, body);
  }

  async gerarRelatorioPedidosPorCliente(body: FiltroRelatorioPedidosPorCliente) {
    let url = "/api/Relatorios/PedidosPorCliente";
    return this.post(url, body);
  }
}
